import { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Modal } from 'react-bootstrap';

import { membresiaCliente, desactivarRenovacionMembresia } from '../../actions/clientes';

const GestionarMembresia = ({ membresia, reestablecerMembresia }) => {

    const dispatch = useDispatch();

    const [membresiaActualData, setMembresiaActualData] = useState({
        id: null,
        id_cliente: null,
        nombre: null,
        status: null,
        cancel_at_period_end: false,
        stripe_price_id: null
    });

    const [membresiaModal, setMembresiaModal] = useState(false);
    const [statusProcesar, setStatusProcesar] = useState(false);

    const handleCancelar = async () => {
        await setStatusProcesar(true);
        await dispatch(membresiaCliente({ id: membresiaActualData.id, id_cliente: membresiaActualData.id_cliente }));
        await handleCerrar();
        await setStatusProcesar(false);
    }

    const handleDesactivarRenovacion = async () => {
        await setStatusProcesar(true);
        await dispatch(desactivarRenovacionMembresia({ id_contratacion: membresiaActualData.id, id_cliente: membresiaActualData.id_cliente }));
        await handleCerrar();
        await setStatusProcesar(false);
    }

    const handleCerrar = () => {
        if(!statusProcesar){
            setMembresiaActualData({ id: null, id_cliente: null, nombre: null, status: null, cancel_at_period_end: false, stripe_price_id: null });
            reestablecerMembresia(null);
            setMembresiaModal(false);
        }
    }

    useEffect(() => {
        if(membresia){
            setMembresiaActualData({
                id: membresia._id,
                id_cliente: membresia.id_cliente,
                nombre: membresia.nombre,
                status: membresia.status,
                cancel_at_period_end: membresia.cancel_at_period_end ?? false,
                stripe_price_id: membresia.stripe_price_id ?? null
            });
            setMembresiaModal(true);
        }
    }, [membresia]);

    const isStripe = !!membresiaActualData.stripe_price_id;

    return (
        <Modal size="md" show={membresiaModal} backdrop="static" centered onHide={() => handleCerrar()}>
            <Modal.Header closeButton>
                <Modal.Title>
                    {isStripe ? 'Administrar membresía' : 'Cancelar membresía'}
                </Modal.Title>
            </Modal.Header>

            {/* Stripe — renovación activa: mostrar opciones */}
            {isStripe && !membresiaActualData.cancel_at_period_end && (
                <>
                    <Modal.Body>
                        <p className="mb-3">Gestiona la membresía <strong>{membresiaActualData.nombre}</strong> del cliente.</p>
                        <div className="mb-3 p-3 border rounded">
                            <h6 className="fw-bold mb-1"><i className="fa-solid fa-ban me-2 text-warning"></i>Desactivar renovación</h6>
                            <p className="text-muted mb-2" style={{ fontSize: '0.875rem' }}>
                                La membresía no se renovará al final del periodo. El cliente mantendrá acceso hasta que venza.
                            </p>
                            {
                                statusProcesar
                                    ? <button type="button" className="btn btn-warning btn-sm" disabled><span className="spinner-border spinner-border-sm me-1"/>Procesando...</button>
                                    : <button type="button" className="btn btn-warning btn-sm" onClick={() => handleDesactivarRenovacion()}><i className="fa-solid fa-ban me-1"></i>Desactivar renovación</button>
                            }
                        </div>
                        <div className="p-3 border rounded">
                            <h6 className="fw-bold mb-1"><i className="fa-solid fa-circle-xmark me-2 text-danger"></i>Cancelar membresía</h6>
                            <p className="text-muted mb-2" style={{ fontSize: '0.875rem' }}>
                                Cancela la membresía de forma inmediata. El cliente perderá acceso al final del periodo activo.
                            </p>
                            {
                                statusProcesar
                                    ? <button type="button" className="btn btn-outline-danger btn-sm" disabled><span className="spinner-border spinner-border-sm me-1"/>Procesando...</button>
                                    : <button type="button" className="btn btn-outline-danger btn-sm" onClick={() => handleCancelar()}><i className="fas fa-times fa-sm me-1"></i>Cancelar membresía</button>
                            }
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <button type="button" className="btn btn-secondary" onClick={() => handleCerrar()} disabled={statusProcesar}>Volver</button>
                    </Modal.Footer>
                </>
            )}

            {/* Stripe — renovación ya desactivada */}
            {isStripe && membresiaActualData.cancel_at_period_end && (
                <>
                    <Modal.Body>
                        <div className="alert alert-warning mb-3">
                            <i className="fa-solid fa-circle-info me-2"></i>
                            La renovación automática de <strong>{membresiaActualData.nombre}</strong> ya está desactivada. El cliente conserva acceso hasta el final del periodo.
                        </div>
                        <p>Si lo requieres, puedes cancelar la membresía de forma inmediata.</p>
                    </Modal.Body>
                    <Modal.Footer>
                        <button type="button" className="btn btn-secondary" onClick={() => handleCerrar()} disabled={statusProcesar}>Cerrar</button>
                        {
                            statusProcesar
                                ? <button type="button" className="btn btn-danger" disabled><span className="spinner-border spinner-border-sm me-1"/>Cancelando...</button>
                                : <button type="button" className="btn btn-outline-danger" onClick={() => handleCancelar()}><i className="fas fa-times fa-sm me-1"></i> Cancelar ahora</button>
                        }
                    </Modal.Footer>
                </>
            )}

            {/* No Stripe — flujo de cancelación simple */}
            {!isStripe && (
                <>
                    <Modal.Body>
                        <p>¿Deseas cancelar la membresía <strong>{membresiaActualData.nombre}</strong>?</p>
                    </Modal.Body>
                    <Modal.Footer>
                        <button type="button" className="btn btn-danger mr-3" onClick={() => handleCerrar()} disabled={statusProcesar}><i className="fas fa-times fa-sm"></i> No</button>
                        {
                            statusProcesar
                                ? <button type="button" className="btn btn-success" disabled><span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Sí</button>
                                : <button type="button" className="btn btn-success" onClick={() => handleCancelar()}><i className="fas fa-check fa-sm"></i> Sí</button>
                        }
                    </Modal.Footer>
                </>
            )}
        </Modal>
    )
}

export default GestionarMembresia;
